import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { CryptoService, HttpService, IdentityService, NotifyService, ResourceService, ValidatorService, ExcelService, ExportService } from "./bundles/services.bundle";
import { RequestInterceptor } from "./interceptors/request.interceptor";
import { SharedCommonModule } from "./shared.common.module";
import { SharedLibsModule } from "./shared.libs.module";
import { OrganizationService } from "./Resolver-Service/organization.service";
import { OrganizationResolver } from "./Resolvers/organization.resolver.service";
import { MeasuresService } from "./Resolver-Service/measures.service";
import { MeasuresResolver } from "./Resolvers/measures.resolver"

@NgModule({
    imports: [
        SharedCommonModule,
        SharedLibsModule
    ],
    exports: [
        SharedCommonModule,
        SharedLibsModule
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                IdentityService, NotifyService, HttpService, ResourceService, ValidatorService, CryptoService, ExcelService, ExportService, OrganizationService, OrganizationResolver, MeasuresService, MeasuresResolver,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: RequestInterceptor,
                    multi: true
                }
            ]
        };
    }
}